import { Table } from 'components/tables/Table';
import { Company } from 'domain/company/Company';
import React, { useMemo } from 'react';
import { providerBlacklistTableColumns } from './providerBlacklistTableColumns';

export const ProviderBlacklistCompanyTable: React.FC<{
	blacklistedCompanies: Company[];
	removeCompany: (company: Company) => void;
	addedCompanies?: Company[];
	disabled?: boolean;
}> = ({ blacklistedCompanies, removeCompany, addedCompanies, disabled }) => {
	const columns = useMemo(
		() => [
			providerBlacklistTableColumns.name(addedCompanies),
			providerBlacklistTableColumns.youniumAccountNumber(addedCompanies),
			providerBlacklistTableColumns.actions(removeCompany, disabled),
		],
		[addedCompanies, disabled],
	);

	// Sort companies alphabetically by name, but put added companies at the top
	const sortedCompanies = useMemo(() => {
		const addedCompanyIds = addedCompanies?.map((c) => c.id) || [];
		const originalCompanies = blacklistedCompanies.filter(
			(c) => !addedCompanyIds.includes(c.id),
		);

		const addedCompaniesList = addedCompanies
			? [...addedCompanies].sort((a, b) => a.name.localeCompare(b.name))
			: [];

		const originalCompaniesList = originalCompanies.sort((a, b) =>
			a.name.localeCompare(b.name),
		);

		return [...addedCompaniesList, ...originalCompaniesList];
	}, [blacklistedCompanies, addedCompanies]);

	return (
		<Table<Company>
			columns={columns}
			data={sortedCompanies}
			withPagination={sortedCompanies.length > 10}
			withSearch
			showRowCount
		/>
	);
};
